export * from "./MailchimpEditForm"


// WEBPACK FOOTER //
// ./src/integration/form/mailchimp/index.ts